// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Skills----Skills-module---root---2NKQW","title":"src-components-Skills----Skills-module---title---mYnA0","tag":"src-components-Skills----Skills-module---tag---14oJB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skills/Skills.module.css
// module id = 303
// module chunks = 35783957827783